import React from 'react';
import PropTypes from 'prop-types';
import ButtonTooltip from '../ButtonTooltip/ButtonTooltip';

import withIdContext from '../../decorators/withIdContext';
import SecondaryActionWithMenu from './SecondaryActionWithMenu/SecondaryActionWithMenu';

const SecondaryAction = ({
  disabled,
  label,
  onClick,
  type,
  disabledReason,
  disabledReasonPlacement,
  isLoading,
}) => (
  <ButtonTooltip
    btStyle="primary"
    type={type}
    disabled={disabled}
    onClick={onClick}
    disabledReason={disabledReason}
    disabledReasonPlacement={disabledReasonPlacement}
    label={label}
    isLoading={isLoading}
  />
);

SecondaryAction.WithMenu = SecondaryActionWithMenu;

SecondaryAction.propTypes = {
  /** Button label */
  label: PropTypes.string,
  /** Button type */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  /** Disable button */
  disabled: PropTypes.bool,
  /** Loading spinner and disabling button */
  isLoading: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  onClick: PropTypes.func.isRequired,
  /** The tooltip describing why the action is disabled */
  disabledReason: PropTypes.string,
  /** Where the tooltip should pop up relative to the action */
  disabledReasonPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
};

SecondaryAction.defaultProps = {
  label: '',
  type: 'button',
  disabled: false,
  isLoading: false,
  disabledReason: null,
  disabledReasonPlacement: 'top',
};

export default withIdContext()(SecondaryAction);
